import { autoinject, computedFrom, transient, useView } from "aurelia-framework";
import { ChildComponent } from "../../../child-component";
import { RightShipInspectionClientModel, RightShipInspectionReportEnum } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
import { NotificationClientService } from "../../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { Reflection } from "../../../../../../utilities/reflection";

@autoinject
@transient()
@useView('views/pages/modules/rightship-inspection/steps/preliminary-report/rightship-inspection-preliminary-report.html')
export class RightshipInspectionPreliminaryReport extends ChildComponent<RightShipInspectionClientModel> {

    constructor(notificationsService: NotificationClientService, i18N: I18N) {
        super(notificationsService, i18N);
    }
    
    @computedFrom(Reflection.getPropertyPath<RightshipInspectionPreliminaryReport>(z => z.item),
        Reflection.getPropertyPath<RightshipInspectionPreliminaryReport>(z => z.item.reportData))
    get reportDataLength() {
        return this.item && this.item.reportData && this.item.reportData[RightShipInspectionReportEnum.PreliminaryReport] ?
            this.item.reportData[RightShipInspectionReportEnum.PreliminaryReport].length : 0;
    }

    @computedFrom(Reflection.getPropertyPath<RightshipInspectionPreliminaryReport>(z => z.item),
        Reflection.getPropertyPath<RightshipInspectionPreliminaryReport>(z => z.item.reportData))
    get reportData() {
        return this.item && this.item.reportData && this.item.reportData[RightShipInspectionReportEnum.PreliminaryReport] ?
            this.item.reportData[RightShipInspectionReportEnum.PreliminaryReport].map(x => {
                if (x.bookmark == "INSPECTION_DATE" && x.value)
                    x.value = x.value.replace(" 12:00AM", "");
                return x;
            }) : [];
    }
}